import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface ScstCommitteeMember {
  sno: number;
  memberName: string;
  designation: string;
  position: string;
}

@Component({
  selector: 'app-instructors-page-three',
  templateUrl: './instructors-page-three.component.html',
  styleUrls: ['./instructors-page-three.component.scss']
})
export class InstructorsPageThreeComponent implements OnInit {
  isToggled = false;

  committeeMembers: ScstCommitteeMember[] = [
    {
      sno: 1,
      memberName: 'Dr. K. R. Ramela',
      designation: 'Professor / EEE',
      position: 'Chairperson'
    },
    {
      sno: 2,
      memberName: 'Dr. S. Saravana Kumar',
      designation: 'Professor / Automobile',
      position: 'Member'
    },
    {
      sno: 3,
      memberName: 'Mr. A. Athimoolam',
      designation: 'Associate Professor / S&H',
      position: 'Member'
    },
    {
      sno: 4,
      memberName: 'Mr. A. Prabu',
      designation: 'Assistant Professor / EEE',
      position: 'Member'
    },
    {
      sno: 5,
      memberName: 'Mr. G. Alagumurugan',
      designation: 'Assistant Professor / Civil',
      position: 'Member'
    },
    {
      sno: 6,
      memberName: 'Mr. C. Harshwinth (II AI&ML)',
      designation: 'Student',
      position: 'Member'
    },
    {
      sno: 7,
      memberName: 'Ms. M. Ganikasri (III Civil)',
      designation: 'Student',
      position: 'Member'
    }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  trackBySno(index: number, item: ScstCommitteeMember): number {
    return item.sno;
  }
}